import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'
import {
  assertTrainingWriteScope,
  trainingApiPrefix,
  trainingQueryKey,
  TRAINING_QUERY_KEYS,
  type TrainingApiOptions,
} from '../../training-modules/trainingModuleApi'

export function useReorder(programId?: string, { target = 'legacy' }: TrainingApiOptions = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    retry: target === 'modern' ? false : undefined,
    scope: target === 'modern' ? { id: `training-order:${programId}` } : undefined,
    mutationFn: async (values: { order: string[] }) => {
      assertTrainingWriteScope(programId, target)
      const resource = target === 'modern' ? 'programs' : 'program'
      const { data } = await apiClient.patch(
        `${trainingApiPrefix(target)}/${resource}/${programId}/training-modules`,
        { order: values.order }
      )
      return data
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: trainingQueryKey(TRAINING_QUERY_KEYS.configuration, programId, target),
      })
    },
  })
}
